import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: localStorage.getItem('isSidebarMinimized') ? JSON.parse(<string>localStorage.getItem('isSidebarMinimized')) : false,
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized;
      localStorage.setItem('isSidebarMinimized', this.isSidebarMinimized);
    },
  },
})
